export default {
    topics: [
        {
            title: ' RunHypothesis ',
            href: 'sm-remaHypothesis-RunHypothesis.html',
            attributes: { 'data-id': 'sm-remaHypothesis-RunHypothesis' },
            menu: { hasChildren: false },
            tocID: 'sm-remaHypothesis-RunHypothesis-d66e3671',
            topics: [],
        },
        {
            title: ' Schedule ',
            href: 'sm-remaHypothesis-Schedule.html',
            attributes: { 'data-id': 'sm-remaHypothesis-Schedule' },
            menu: { hasChildren: false },
            tocID: 'sm-remaHypothesis-Schedule-d66e3679',
            topics: [],
        },
        {
            title: ' Start ',
            href: 'sm-remaHypothesis-Start.html',
            attributes: { 'data-id': 'sm-remaHypothesis-Start' },
            menu: { hasChildren: false },
            tocID: 'sm-remaHypothesis-Start-d66e3687',
            topics: [],
        },
        {
            title: ' Stop ',
            href: 'sm-remaHypothesis-Stop.html',
            attributes: { 'data-id': 'sm-remaHypothesis-Stop' },
            menu: { hasChildren: false },
            tocID: 'sm-remaHypothesis-Stop-d66e3695',
            topics: [],
        },
    ],
};

